import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import { useCampaignId, useTypes } from '../hooks';
import { t } from '../i18n';

export function SearchPage() {
  const cid = useCampaignId();
  const types = useTypes(cid);
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get('q') ?? '');
  const [debounced, setDebounced] = useState(q);

  useEffect(() => {
    const h = window.setTimeout(() => {
      setDebounced(q);
      setParams(q ? { q } : {}, { replace: true });
    }, 200);
    return () => window.clearTimeout(h);
  }, [q, setParams]);

  const results = useQuery({
    queryKey: ['search', cid, debounced],
    queryFn: () => api.search(cid, debounced),
    enabled: debounced.trim().length > 0,
    placeholderData: (prev) => prev,
  });

  return (
    <div className="page-narrow">
      <h1>{t('search.title')}</h1>
      <input className="search-input" autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('search.placeholder')} />
      {results.data && results.data.length === 0 && debounced && <p className="muted">{t('search.none')}</p>}
      <ul className="search-results">
        {results.data?.map((hit) => (
          <li key={hit.id}>
            <Link to={`/c/${cid}/n/${hit.id}`}>
              <span className="type-dot" style={{ background: types.byKey.get(hit.typeKey)?.color }} />
              <strong>{hit.title}</strong>
              {hit.folder && <span className="muted small"> · {hit.folder}</span>}
            </Link>
            {/* Ausschnitt ist serverseitig escaped, nur <mark> ist enthalten */}
            <div className="snippet" dangerouslySetInnerHTML={{ __html: hit.snippet }} />
          </li>
        ))}
      </ul>
    </div>
  );
}
